import getBasePath from '../../../../common/functions/api-resource';
import genericActions from './generic-resource';

const basePath = getBasePath('api', 'parametrizacao-acao');

const parametrizacaoAcaoActions = {
  ...genericActions(basePath),
  buscar: { method: 'GET', url: `${basePath}` },
  obterPasso1: { method: 'GET', url: `${basePath}/{id}/passo1` },
  obterPasso2: { method: 'GET', url: `${basePath}/{id}/passo2` },
  obterPasso3: { method: 'GET', url: `${basePath}/{id}/passo3` },
  obterPasso4: { method: 'GET', url: `${basePath}/{id}/passo4` },
  obterPasso5: { method: 'GET', url: `${basePath}/{id}/passo5` },
  obterPasso6: { method: 'GET', url: `${basePath}/{id}/passo6` },
  obterPasso7: { method: 'GET', url: `${basePath}/{id}/passo7` },
  obterPasso8: { method: 'GET', url: `${basePath}/{id}/passo8` },
};

export default resource => resource(`${basePath}`, {}, parametrizacaoAcaoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/parametrizacao-acao.js